import { render, staticRenderFns } from "./headerLayout.vue?vue&type=template&id=6837ad9a&"
import script from "./headerLayout.vue?vue&type=script&lang=js&"
export * from "./headerLayout.vue?vue&type=script&lang=js&"
import style0 from "./headerLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports